import { Directive, Self, HostListener,
         OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { Tool, ToolService } from '../shared';
import { ToolbarComponent } from './toolbar.component';


@Directive({
  selector: '[igoToolbarBinding]'
})
export class ToolbarBindingDirective implements OnInit, OnDestroy {

  private component: ToolbarComponent;
  private selectedTool$$: Subscription;

  @HostListener('select', ['$event']) onSelect(tool: Tool) {
    this.toolService.selectTool(tool);
  }

  constructor(@Self() component: ToolbarComponent,
              private toolService: ToolService) {
    this.component = component;
  }

  ngOnInit() {
    this.selectedTool$$ = this.toolService.selectedTool$
      .subscribe(tool => this.component.selectedTool = tool);
  }

  ngOnDestroy() {
    this.selectedTool$$.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/toolbar/toolbar-binding.directive.ts